<div class="titleWrapper">
  <gl-pro-icon></gl-pro-icon>
  <div class="switchText" [class.activeSwitch]="!isSwitchSet" (click)="switchSet(false)">
    {{ 'semi_trailer' | translate }}
  </div>
  @if (setActive) {
    <div class="spaceBetweenButtons">|</div>
  }
  @if (setActive) {
    <div
      class="switchText"
      [class.activeSwitch]="isSwitchSet"
      (click)="switchSet(true)"
      >
      {{ 'trailer' | translate }}
    </div>
  }
  <div class="info-icon" (click)="openInfoWindow()" #infoTrigger>!</div>

  @if (isInfoWindowOpen) {
    <div
      class="infoWrapper"
      [elementToIgnore]="infoTriggerEl"
      (glMousedownOutside)="openInfoWindow()"
      [@show]
      #infoWindow
      >
      <div class="infoArrow" #infoArrow></div>
      <button icon-button (click)="openInfoWindow()" class="close">
        <gl-icon [name]="'close'" class="close-icon"></gl-icon>
      </button>
      <div class="instructionWrapper">
        <div>{{ 'axle_info' | translate }}</div>
        <div class="line"></div>
        <div class="infoImgWrapper">
          <img class="infoImg" src="/assets/png/semitrailer.png" />
          <div class="axleTitleWrapper">
            <div class="axleTitle firstSemitrailer">
              <div>{{ 'drive_axle' | translate }}</div>
              <div class="lengthAxle">(+200 {{ 'units_cm' | translate }})</div>
            </div>
            <div class="axleTitle secondSemitrailer">
              <div>{{ 'centre_of_the_trailer' | translate }}</div>
              <div class="lengthAxle">(+850 {{ 'units_cm' | translate }})</div>
            </div>
          </div>
          <div class="line"></div>
          <img class="infoImg" src="/assets/png/truck_axle_info.png" />
          <div class="axleTitleWrapper">
            <div class="axleTitle firstTruck">
              <div>{{ 'front_axle' | translate }}</div>
              <div class="lengthAxle">(-100 {{ 'units_cm' | translate }})</div>
            </div>
            <div class="axleTitle secondTruck">
              <div>{{ 'centre_of_the_trailer' | translate }}</div>
              <div class="lengthAxle">(+650 {{ 'units_cm' | translate }})</div>
            </div>
          </div>
          <div class="line"></div>
          <img class="infoImg" src="/assets/png/bus.png" />
          <div class="axleTitleWrapper">
            <div class="axleTitle firstBus">
              <div>{{ 'front_axle' | translate }}</div>
              <div class="lengthAxle">(-230 {{ 'units_cm' | translate }})</div>
            </div>
            <div class="axleTitle secondBus">
              <div>{{ 'rear_axle' | translate }}</div>
              <div class="lengthAxle">(+550 {{ 'units_cm' | translate }})</div>
            </div>
          </div>
        </div>
        <div class="line"></div>
        <div>{{ 'axle_info_second' | translate }}</div>
      </div>
    </div>
  }
</div>

<div class="container">
  <form class="form" [formGroup]="form" #f="ngForm" (keyup.enter)="emitAxles()" [glPremium]="true">
    <div class="inputColumn">
      <!--      <div class="inputContainer" *ngIf="!isSwitchSet">-->
      <!--        <gl-checkbox-->
      <!--          defaultChecked="true"-->
      <!--          formControlName="isBus"-->
      <!--        >{{ 'bus_or_solo' | translate }}-->
    <!--        </gl-checkbox-->
    <!--        >-->
  <!--      </div>-->
  <div class="inputContainer">
    <div class="inputLabel">{{ 'nr_of_axles' | translate }}:</div>
    <gl-input-container class="input">
      <input
        [numericType]="'float'"
        formControlName="quantity"
        number-input
        placeholder="quantity"
        type="number"
        />
    </gl-input-container>
  </div>
  <div class="inputContainer">
    <div class="inputLabel">{{ 'select_axle' | translate }}:</div>
    <gl-select formControlName="selectedAxle">
      @for (value of axlesNrList; track value) {
        <gl-option
          [value]="value"
          [label]="value"
        ></gl-option>
      }
    </gl-select>
  </div>
  <div class="inputContainer">
    <div class="inputLabel">{{ 'distance_from_trailer' | translate }}:</div>
    <gl-input-container>
      <input
        type="text"
        [numericType]="'floatNeg'"
        normal-input
        formControlName="distanceFromSpaceFront"
        />
    </gl-input-container>
  </div>
  <!-- Ukryte przez https://transeu.atlassian.net/browse/GL-3886
  <div class="inputContainer">
    <div class="inputLabel">{{ 'load_without_weight' | translate }}:</div>
    <gl-input-container>
      <input

        type="text"
        [numericType]="'floatNeg'"
        normal-input
        formControlName="emptySpaceLoad"
        />
    </gl-input-container>
  </div>
  -->
  <div class="inputContainer">
    <div class="inputLabel">{{ 'max_permissible_load' | translate }}:</div>
    <gl-input-container>
      <input type="text" [numericType]="'floatNeg'" normal-input formControlName="maxLoad" />
    </gl-input-container>
  </div>
</div>
</form>

<div class="visualization">
  <gl-axle-loads
    [selectedAxle]="form.controls.selectedAxle.value"
    [axles]="axles"
    [isSwitchSet]="isSwitchSet"
    [loadingSpace]="loadingSpace"
    (valueOfAxle)="currentAxleValue($event)"
  ></gl-axle-loads>
</div>
</div>

<div class="buttonRow">
  <button outline-icon-button (click)="delete()">
    <gl-icon name="delete"></gl-icon>
  </button>
  <button outline-icon-button (click)="resetToDefaultValue()">
    <gl-icon name="startArrangement"></gl-icon>
  </button>
</div>
